/**
 * Privacy opt-out cookie. When set, the site:
 *  - skips loading Google Analytics
 *  - skips emitting events to /api/v1/public/track
 *  - skips sending feedback (the form refuses to mount)
 *
 * The cookie is first-party, scoped to the apex domain, lasts 1 year.
 * Spec: docs/specs/sponsor-dashboard.md §13.1
 */

const OPTOUT_COOKIE = 'sd_optout'
const ONE_YEAR_S = 60 * 60 * 24 * 365

function readCookie(name: string): string | null {
    if (typeof document === 'undefined') return null
    const prefix = `${name}=`
    for (const part of document.cookie.split(';')) {
        const trimmed = part.trim()
        if (trimmed.startsWith(prefix)) {
            try {
                return decodeURIComponent(trimmed.slice(prefix.length))
            } catch {
                return trimmed.slice(prefix.length)
            }
        }
    }
    return null
}

export function isOptedOut(): boolean {
    return readCookie(OPTOUT_COOKIE) === '1'
}

export function setOptOut(value: boolean) {
    if (typeof document === 'undefined') return
    if (value) {
        document.cookie = `${OPTOUT_COOKIE}=1; Max-Age=${ONE_YEAR_S}; Path=/; SameSite=Lax; Secure`
    } else {
        document.cookie = `${OPTOUT_COOKIE}=; Max-Age=0; Path=/; SameSite=Lax; Secure`
    }
}
